import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOpenInNewTabIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "#fff",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6886",
		"data-name": "Path 6886",
		d: "M18,19H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5h5a1,1,0,0,0,0-2H5A2,2,0,0,0,3,5V19a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V13a1,1,0,0,0-2,0v5A1,1,0,0,1,18,19ZM14,4a1,1,0,0,0,1,1h2.59L8.46,14.13a1,1,0,0,0,1.41,1.41L19,6.41V9a1,1,0,0,0,2,0V4a1,1,0,0,0-1-1H15A1,1,0,0,0,14,4Z",
		transform: "translate(-3 -3)"
	})
});
export { SvgOpenInNewTabIcon as ReactComponent };
